import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomeOne from "./pages/HomeOne";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import ScrollToTop from "react-scroll-to-top";
import About from "./pages/About";
import Service from "./pages/Service";
import ServiceDetails from "./pages/ServiceDetails";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import Pricing from "./pages/Pricing";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import Track from "./pages/Track";
import RouteScrollToTop from "./elements/RouteScrollToTop";
import Setlocale from "./Setlocale";
import Register from "./pages/Register";
import Profile from "./pages/Profile";
import Changepassword from "./pages/Changepassword";
import Login   from "./pages/Login";
import Authmiddleware from "./middlewares/Authmiddleware";
//orders 
import OrderIndex from "./pages/Orders/Index";
import OrderAdd   from "./pages/Orders/Add";
import  OrderShow  from "./pages/Orders/Show";
import ErrorPage from "./ErrorPage";
function App() {

 

  useEffect(() => {
    AOS.init({
      offset: 0,
      easing: "ease",
      once: true,
    });
    AOS.refresh();
  }, []);

  return (

    <Setlocale>
      <BrowserRouter>
      <RouteScrollToTop /> 

      {/* Language Switcher */}
      
      <Routes>
         <Route exact path='/' element={<HomeOne />} />
        <Route exact path='ar' element={<HomeOne />} />
        <Route exact path='en' element={<HomeOne />} />
        <Route exact path=':lang/about' element={<About />} />
        <Route exact path=':lang/service' element={<Service />} />
        <Route exact path=':lang/service-details/:id' element={<ServiceDetails />} />
        <Route exact path=':lang/blog' element={<Blog />} />
        <Route exact path=':lang/blog-details/:id' element={<BlogDetails />} />
        <Route exact path='/pricing' element={<Pricing />} />
        <Route exact path='/faq' element={<Faq />} />
        <Route exact path=':lang/contact' element={<Contact />} />
        <Route exact path=':lang/track-order' element={<Track />} />
        <Route exact path=":lang/register" element={<Register />} />
        <Route exact path=":lang/login" element={<Login />} />
        {/* profile here */}
        <Route exact path=":lang/profile" element={
          <Authmiddleware>
              <Profile />
          </Authmiddleware>
          } />
        <Route exact path=":lang/change-password" element={
          <Authmiddleware>
              <Changepassword />
          </Authmiddleware>
          } />
        <Route exact path=":lang/orders" element={
          <Authmiddleware>
              <OrderIndex />
          </Authmiddleware>
          } />
        <Route exact path=":lang/orders/add" element={
          <Authmiddleware>
              <OrderAdd />
          </Authmiddleware>
          } />
          <Route exact path=":lang/order-view/:id" element={
          <Authmiddleware>
              <OrderShow />
          </Authmiddleware>
          } />
        <Route path="*" element={<ErrorPage />} />
        <Route path="/401" element={<ErrorPage />} />
      </Routes>

      <ScrollToTop smooth color='#41b06e' />
    </BrowserRouter>
    </Setlocale>
  );
}

export default App;
